import { Path } from 'enums';
import CustomerClaimsModule from 'modules/customer-account/customer-claims.module';
import SavingsModule from 'modules/savings/savings.module';
import SharedCapitalModule from 'modules/shared-capital/shared-capital.module';
import TransactionFDModule from 'modules/transaction/TransactionFD.module';
import TransactionSAModule from 'modules/transaction/TransactionSA.module';
import TransactionSCModule from 'modules/transaction/TransactionSC.module';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

const TransactionPage = () => {
  return (
    <Switch>
      <Route exact path={`${Path.Transaction}/report/savings`} component={SavingsModule} />
      <Route exact path={`${Path.Transaction}/shared-capital`} component={TransactionSCModule} />
      <Route exact path={`${Path.Transaction}/savings`} component={TransactionSAModule} />
      <Route exact path={`${Path.Transaction}/fixed-deposit`} component={TransactionFDModule} />
      <Route exact path={`${Path.Transaction}/report/shared-capital`} component={SharedCapitalModule} />
      <Route exact path={`${Path.Transaction}/claims`} component={CustomerClaimsModule} />
    </Switch>
  );
};

export default TransactionPage;
